export enum Role {
    Admin = 0,
    User = 1,
    SuperAdmin = 2,
    AlternativeRole = 3
}
